import { CompanyMapData } from "./companyMapData";
/**
 * Класс данных новостей банка.
 */
export class MapData {

  public Companies: Array<CompanyMapData> = [];


  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  public constructor(src: any = null) {
    if (src) {
        const sXml: string = src.data ?? "";

        // Парсим XML.
        const parser = new DOMParser();
        const xDoc = parser.parseFromString(sXml, "text/xml");
    
        const xmlFields = xDoc.getElementsByTagName("company");

        for (let i = 0; i < xmlFields.length; i++) {
          const field = xmlFields[i];
          const result: any = {
            CompanyId: field.getElementsByTagName("companyId")[0].innerHTML.trim(),
            Type: field.getElementsByTagName("type")[0].innerHTML.trim(),
            Adress: field.getElementsByTagName("address")[0].innerHTML.trim(),
            Cords: [
              field.getElementsByTagName("coordinates")[0].getElementsByTagName('lat')[0].innerHTML.trim(),
              field.getElementsByTagName("coordinates")[0].getElementsByTagName('lon')[0].innerHTML.trim()
            ]
          }
          if (!!result.CompanyId) {
            this.Companies.push(new CompanyMapData(result));
          }
        }
    }
  }
}
